import React from "react";
import "./HomePage.css";
import HeroSection from "../../components/home/HeroSection/HeroSection";
import WhyChooseUsSection from "../../components/home/WhyChooseUs/WhyChooseUsSection";
import HowItWorksSection from "../../components/home/HowItWorks/HowItWorksPage";
import homePageHeroImg from "../../assets/home-page-hero.png"

import { useNavigate } from "react-router-dom";
const HomePage = () => {
  const handleNavigation = (path) => {
    console.log(`Navigating to: ${path}`);
    window.location.href = path;
  };

  const navigate = useNavigate();
  return (
    <div className="homepage">
      <HeroSection
        title="Wholesome.Trusted."
        subtitle="Essentials for the conscious buyer."
        descriptionpart1="Vanidya brings you organic food, satvik staples and pooja essentials with full transparency from source to shelf. "
        descriptionpart2="Buy from trusted local sellers, help your local community earn with every purchase and make your shopping a force for good."
        description1="Nourish your body, uplift your spirit, honor every tradition"
        primaryCta="Get the App"
        secondaryCta="Grow My Store"
        tertiaryCta="Partner With Us"
        onPrimaryCtaClick={() =>
          navigate('/sellers')
        }
        onSecondaryCtaClick={() => handleNavigation("/community")}
        onTertiaryCtaClick={() => handleNavigation("/get-app")}
        imageUrl={homePageHeroImg}
        showAppBadges={true}
      />

      <WhyChooseUsSection />
      <HowItWorksSection />


      {/* <FaqsHandbookHome /> */}
    </div>
  );
};

export default HomePage;
